import { LocDefs, MapLocKeys } from '@cm/core/localization';
import { userDPRoot } from '../../users-meta';

const dpRoot = `${userDPRoot}|User History`;

export type UserHistoryLoc =
	| 'SPUserHistoryPageTitle'
	| 'SPUserHistoryViewCandidate'
	| 'SPUserHistoryViewUser'
	| 'SPUserHistoryNoHistory';

export const userHistoryLocs: LocDefs<UserHistoryLoc> = {
	SPUserHistoryPageTitle: {
		defaultValue: 'User History TEST',
		description: 'Page title for the user history page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		portal: 'SP',
	},
	SPUserHistoryViewCandidate: {
		defaultValue: 'View Candidate',
		description: 'Link to visit the candidate page.',
		displayPath: `${dpRoot}|View Candidate`,
		displayType: 'Button',
		portal: 'SP',
	},
	SPUserHistoryViewUser: {
		defaultValue: 'View User',
		description: 'Link to visit the user page.',
		displayPath: `${dpRoot}|View User`,
		displayType: 'Button',
		portal: 'SP',
	},
	SPUserHistoryNoHistory: {
		defaultValue: 'No history',
		description: 'Message shown when there is no user history.',
		displayPath: `${dpRoot}|No History`,
		displayType: 'Content',
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<UserHistoryLoc>(userHistoryLocs);
